import workspace from "../../core/workspace";
import store from "./../../../../../../store";
import SlabWorkspace from "./slabWorkspace";
import {getPointField} from "../../../../helpers/sqftHelper";
import sqftShape from "../shapes/sqftShape";
import {isDisabledInPopupShouldBeHidden, SHAPE_PART_ID, SQFT_MODE} from "../../../../constants";
import config from "../../store/sqftConfig";
import workspaceControllers from "../../store/workspaceControllers";
import RenderFigures from "../../helpers/renderFigures";
import RenderParts from "../../helpers/renderParts";
import {getViewportSize} from "../../store/canvasHelper";
import COLOR_THEMES from "../../store/colorThemes";

export const renderSlabRightPart = (ctx, isFullRender = false) => {
  let slabState = store.getState().sqftSlabState;
  let croppedImages = slabState.croppedSlabImages;
  let scale = workspace.getScale();
  let slabWorkspacePos = SlabWorkspace.getCenter();
  let shapes = workspace.getShapes();

  //this will render shapes without rotation
  shapes.forEach((shape) => {
    if (!(shape instanceof sqftShape)
      || shape.rotatedDegreesSlab !== 0
      || (isDisabledInPopupShouldBeHidden() && shape.isDisabledInPopup)
      || shape.partId === SHAPE_PART_ID.slabPlaceHolder
    ) {
      return
    }
    let pos = shape.getRegularPosition();
    //let posSlab = shape.shapeSlab.__absolutePos ? shape.getSlabAbsolutePosition() : shape.getSlabPosition();
    let posSlab = shape.shapeSlab.getPosition();
    let shapeRegularPointField = getPointField(pos.x, pos.y, workspace);
    let shapeSlabPointField = getPointField(posSlab.x, posSlab.y, SlabWorkspace);

    const { canvasWidth } = getViewportSize(ctx.canvas);
    let staticOffset = {
      x: shapeRegularPointField.x - slabWorkspacePos.x + canvasWidth / 2,
      y: shapeRegularPointField.y - slabWorkspacePos.y
    };
    ctx.save();
    !isFullRender ? clearSlabLeftPart(ctx) : null;

    //render borders only for core shapes
    ctx.beginPath();
    if (shape.partId === SHAPE_PART_ID.seamPiece) {
      shape.shapeSlab.renderLinesWithoutStroke(ctx, staticOffset, SQFT_MODE.regular);
      ctx.lineWidth = 0;
      ctx.strokeStyle = 'rgba(0,0,0,0.0)';
    } else {
      shape.shapeSlab.renderLinesWithoutStroke(ctx, staticOffset, SQFT_MODE.regular);
      //if (isFullRender) {
        // console.log("scale", scale);
        // console.log("ctx.canvas.width / 2", ctx.canvas.width / 2);
        // console.log("pos", pos);
        // console.log("slabWorkspacePos2", slabWorkspacePos);
        // console.log("offset = workspace.getOffset();", workspace.getOffset());
        // console.log("shapeRegularPointField", shapeRegularPointField);
        // console.log("staticOffset", staticOffset);
      //}
    }
    ctx.closePath();
    ctx.stroke();

    //do not clip shapes with seam (clip only children)
    if (shape.isWithShapePieces()) {
      ctx.restore();
      return
    }
    ctx.clip();
    for (let slabIndex in croppedImages) {
      let movableImage = croppedImages[slabIndex];
      const movableImagePosition = movableImage.getPosition();
      let movableImagePointField = getPointField(movableImagePosition.x, movableImagePosition.y, SlabWorkspace);
      let movableImageSize = movableImage.getSize();

      // ctx.translate(
      //   staticOffset.x + (movableImagePointField.x - shapeSlabPointField.x),
      //   staticOffset.y + (movableImagePointField.y - shapeSlabPointField.y)
      // );
      // console.log("movableImagePosition", movableImagePosition);
      // console.log("movableImage pos", movableImage.pos);
      // console.log("posSlab", posSlab);
      // console.log("pos", pos);
      // console.log("shapeRegularPointField", shapeRegularPointField);
      // console.log("movableImagePointField", movableImagePointField);
      // console.log("shapeSlabPointField", shapeSlabPointField);

      // debugger // eslint-disable-line no-debugger
      // ctx.rotate(90 * Math.PI / 180);

      const { canvasWidth } = getViewportSize(ctx.canvas);
      ctx.drawImage(
        movableImage.getImage(),
        //shape.pos.x * scale, shape.pos.y * scale,
        canvasWidth / 2 + (movableImagePointField.x - shapeSlabPointField.x + shapeRegularPointField.x) - slabWorkspacePos.x,
        (movableImagePointField.y - shapeSlabPointField.y + shapeRegularPointField.y) - slabWorkspacePos.y,
        movableImageSize.width * scale,
        movableImageSize.depth * scale
      );
    }
    ctx.restore();
  });

  //this will render shapes with rotation ( it is translate point field to shape center and rotate it with images)
  shapes.forEach((shape) => {
    if (!(shape instanceof sqftShape)
      || shape.rotatedDegreesSlab === 0
      || (isDisabledInPopupShouldBeHidden() && shape.isDisabledInPopup)
      || shape.partId === SHAPE_PART_ID.slabPlaceHolder
    ) {
      return
    }
    let pos = shape.getRegularPosition();
    let posSlab = shape.shapeSlab.getPosition();
    let shapeRegularPointField = getPointField(pos.x, pos.y, workspace);
    let shapeSlabPointField = getPointField(posSlab.x, posSlab.y, SlabWorkspace);
    const { canvasWidth } = getViewportSize(ctx.canvas);

    let staticOffset = {
      x: shapeRegularPointField.x - slabWorkspacePos.x + canvasWidth / 2,
      y: shapeRegularPointField.y - slabWorkspacePos.y
    };

    let shapeCenter = shape.getCenter();
    //todo check if this can be used instead of shapeCenter()
    //let shapeCenterSlab = ShapeHelper.getCenterPoint(points, true);
    //void shapeCenterSlab;

    let shapeCenterOffset = {x: 0, y: 0};
    shapeCenterOffset.x = shapeCenter.x * scale
    shapeCenterOffset.y = shapeCenter.y * scale

     //console.log("pos", pos);
     //console.log("shapeRegularPointField", shapeRegularPointField);
     //console.log("shapeSlabPointField", shapeSlabPointField);
     //console.log("shapeCenter", shapeCenter);
     //console.log("staticOffset", staticOffset);
     //console.log("shapeCenterOffset", shapeCenterOffset);
    ctx.save();
    !isFullRender ? clearSlabLeftPart(ctx) : null;
    ctx.translate(staticOffset.x + shapeCenterOffset.x, staticOffset.y + shapeCenterOffset.y);
    ctx.rotate(shape.rotatedDegreesSlab * Math.PI / 180);
    //render borders only for core shapes
    ctx.beginPath();
    if (shape.partId === SHAPE_PART_ID.seamPiece) {
      shape.shapeSlab.renderLinesWithoutStroke(ctx, {x: -shapeCenterOffset.x, y: -shapeCenterOffset.y}, SQFT_MODE.slab);
      ctx.lineWidth = 0;
      ctx.strokeStyle = 'rgba(0,0,0,0.0)';
      //ctx.lineWidth = 3; //test mode
      //ctx.strokeStyle = 'rgba(0,0,0)'; //test mode
    } else {
      shape.shapeSlab.renderLinesWithoutStroke(ctx, {x: -shapeCenterOffset.x, y: -shapeCenterOffset.y}, SQFT_MODE.slab);
    }
    ctx.closePath();
    ctx.stroke();

    //do not clip shapes with seam (clip only children)
    if (shape.isWithShapePieces()) {
      ctx.restore();
      return
    }
    ctx.clip();
    for (let slabIndex in croppedImages) {
      let movableImage = croppedImages[slabIndex];
      const movableImagePosition = movableImage.getPosition();
      let movableImagePointField = getPointField(movableImagePosition.x, movableImagePosition.y, SlabWorkspace);
      let movableImageSize = movableImage.getSize();

      ctx.drawImage(
        movableImage.getImage(),
        -shapeCenterOffset.x + (movableImagePointField.x - shapeSlabPointField.x),
        -shapeCenterOffset.y + (movableImagePointField.y - shapeSlabPointField.y),
        movableImageSize.width * scale,
        movableImageSize.depth * scale
        // ctx.canvas.width / 2 + (movableImagePointField.x - shapeSlabPointField.x + shapeRegularPointField.x) - slabWorkspacePos.x,
        // (movableImagePointField.y - shapeSlabPointField.y + shapeRegularPointField.y) - slabWorkspacePos.y,
        // movableImage.pos.x * scale,
        // movableImage.pos.y * scale,
      );
    }
    ctx.restore();
    renderDevMode(ctx, shape);
  });
};

const clearSlabLeftPart = (ctx) => {
  const { canvasWidth, canvasHeight } = getViewportSize(ctx.canvas);
  ctx.beginPath();
  ctx.rect(canvasWidth / 2, 0, canvasWidth, canvasHeight);
  ctx.closePath();
  ctx.stroke();
  ctx.clip();
}

export const renderSlabWorkspace = (ctx) => {
  drawSlabRightPart(ctx);
  drawSlabMidDivider(ctx);
};

const drawSlabMidDivider = (ctx) => {
  const { canvasHeight } = getViewportSize(ctx.canvas);
  ctx.beginPath();
  ctx.strokeStyle = '#d5d5d5';
  ctx.lineWidth = 1;
  ctx.moveTo(SlabWorkspace.getRightPartWidth(ctx), 0);
  ctx.lineTo(SlabWorkspace.getRightPartWidth(ctx), canvasHeight);
  ctx.stroke();
};

const drawSlabRightPart = (ctx) => {
  const { canvasWidth, canvasHeight } = getViewportSize(ctx.canvas);
  ctx.fillStyle = '#ffffff';
  ctx.rect(SlabWorkspace.getRightPartWidth(ctx), 0, canvasWidth, canvasHeight);
  ctx.fill();
};

const renderDevMode = (ctx, shape) => {
  if (config.isDevMode()) {
    // render pos
    ctx.save();
    ctx.beginPath();
    let pf = getPointField(shape.pos.x, shape.pos.y);
    ctx.arc(pf.x, pf.y, 5, 0, 2 * Math.PI);
    ctx.stroke();
    ctx.closePath();

    //render shape center
    ctx.beginPath();
    let shapeCenter = shape.getCenter();
    const pos = getPointField(shapeCenter.x, shapeCenter.y, this);
    ctx.arc(pos.x, pos.y, 12, 0, 2 * Math.PI);

    ctx.stroke();
    ctx.closePath();
    ctx.restore();
  }
}

export const renderMeasurementsAroundSnappedShapes = (ctx) => {
  ctx.save();
  ctx.strokeStyle = COLOR_THEMES[config.activeTheme].primary;
  for (const snappedShapeGroup of workspaceControllers.snappedShapeGroups.getResources()) {
    const shapes = workspaceControllers.snappedShapeGroups.getSnappedShapes(snappedShapeGroup);
    if (shapes.length > 1) { //we will render only shape group if it has two shapes
      const measurementPoints = workspaceControllers.snappedShapeGroups.getMeasurementPoints(snappedShapeGroup);

      renderMeasurementArrows(ctx, measurementPoints);
      renderMeasurementLength(ctx, measurementPoints);
      //console.log("measurementPoints", measurementPoints);

      //this is for the test purposes
      // const measurementPoints2 = sqftShapeManager.getShapesContourPointsPointField(shapes);
      // console.log("measurementPoints2", measurementPoints2);
      // renderMeasurementArrows(ctx, measurementPoints2);
      // renderMeasurementLength(ctx, measurementPoints2);
    }
  }
  ctx.restore();
}

export const renderMeasurementArrows = (ctx, measurementPoints) => {
  RenderFigures.drawArrowsAroundPoints(ctx, measurementPoints);
}

export const renderMeasurementLength = (ctx, measurementPoints) => {
  RenderParts.drawMeasurementAroundPoints(ctx, measurementPoints);
}
